import styled from 'styled-components'

export const Wrapper = styled.div<any>`
  width: 100%;
  border-radius: 10px;
  background-color: ${props => props.theme.palette.general.light};
  box-shadow: inset 0 1px 3px 0 rgba(188, 183, 183, 0.5);
  ${props => props.isSofiaAndGrace && `
    padding: 4px;
    box-sizing: border-box;
  `}
`

export const Filler = styled.div<any>`
  height: ${props => props.isSofiaAndGrace ? '8px' : '11px'};
  width: ${props => props.width}%;
  max-width: 100%;
  border-radius: 9.5px;
  background-color: ${props => props.isSofiaAndGrace ? props.theme.productSelector.reviewColorDark : props.theme.palette.general.grey};
`
